import React, { useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import {
  Button,
  Card,
  CardBody,
  Table,
  Modal,
  ModalHeader,
  ModalFooter,
} from "reactstrap"

import Paginations from "components/Common/Pagination"
import { formatDateForAPI } from "components/Common/Utils"
import Filters from "components/Shared/Filters"
import Spinners from "components/Shared/Spinners"
import {
  setOtherTabPayload as setPayload,
  resetOtherTabsPayload as resetPayload,
} from "store/reducers/interviewsReducer.js"

import { getAssessmentList } from "store/actions/interviewsAction"
import { usePermissions } from "hooks"
import { getJobTitlesList } from "store/actions/commonAction"

const InterviewTabs = ({ activeTab }) => {
  const {
    loading,
    assessmentsList,
    perPage,
    totalPages,
    totalCount,
    currentPage,
    otherTabPayload: payload,
  } = useSelector(state => state.Interviews)
  const { jobTitlesList } = useSelector(state => state.Common)

  const {
    t,
    i18n: { language },
  } = useTranslation()
  const dispatch = useDispatch()
  const { showAll, permissions } = usePermissions("interview_schedule")
  const { permissions: iePermissions } = usePermissions("interview_evaluation")

  const [modal, setModal] = useState(false)
  const [selectedItem, setSelectedItem] = useState({})
  const [trigger, setTrigger] = useState(false)

  const toggle = () => setModal(!modal)

  useEffect(() => {
    getAllData()
  }, [activeTab, trigger])

  useEffect(() => {
    dispatch(resetPayload())
  }, [activeTab])

  const getAllData = () => {
    let obj = {
      ...payload,
      filters: {
        ...payload.filters,
        is_trial_run:
          payload.filters.is_trial_run === "all"
            ? null
            : payload.filters.is_trial_run === "yes"
            ? 1
            : 0,
        type: activeTab,
        date_range:
          payload.filters.date_range.length === 2
            ? {
                start_date: formatDateForAPI(payload.filters.date_range[0]),
                end_date: formatDateForAPI(payload.filters.date_range[1]),
              }
            : {},
      },
    }

    if (activeTab === "2") {
      obj = {
        ...obj,
        filters: {
          ...obj.filters,
          is_trial_run:
            payload.filters.is_trial_run === "all"
              ? null
              : payload.filters.is_trial_run === "yes"
              ? 1
              : 0,
        },
      }
    }

    dispatch(getAssessmentList(obj))
    //   navigate(`/interviews?page=${page || pageNumber}`)
  }

  const onPageChange = page => {
    dispatch(setPayload({ page_number: page }))
    setTrigger(!trigger)
  }
  const handleSearch = () => {
    setTrigger(!trigger)
  }

  const handleReset = () => {
    dispatch(resetPayload())
    setTrigger(!trigger)
  }

  useEffect(() => {
    dispatch(getJobTitlesList())
  }, [])

  const formattedJobTitles = useMemo(() => {
    if (!jobTitlesList) return []

    return jobTitlesList.map(jobTitle => ({
      value: jobTitle.id,
      label: jobTitle[language === "en" ? "name" : "name_ar"],
    }))
  }, [jobTitlesList])

  let filters = {
    keyword: {
      type: "text",
      placeholder: t("Search by name,phone or national id"),
      label: t("Search By"),
      colSize: 4,
    },

    order_by: {
      type: "select",
      placeholder: t("Select Order"),
      label: t("Select Order"),
      options: [
        { value: 1, label: t("Ascending") },
        { value: -1, label: t("Descending") },
      ],
      colSize: 4,
    },
    // dateRange: { type: "dateRange", label: t("Select Date") },
  }

  if (activeTab === "2") {
    const { order_by, keyword } = filters
    filters = {
      keyword,
      job_title_ids: {
        type: "select",
        placeholder: t("Select Job Title"),
        label: t("Job Title"),
        colSize: 4,
        options: formattedJobTitles,
        multiple: true,
      },
      is_trial_run: {
        type: "select",
        placeholder: t("Select Trial Operation"),
        label: t("Select Trial Operation"),
        options: [
          { value: "all", label: t("All") },
          { value: "yes", label: t("Yes") },
          { value: "no", label: t("No") },
        ],
        colSize: 3,
      },

      order_by,
    }
  }

  return (
    <>
      {loading ? (
        <Spinners />
      ) : (
        <div>
          {/* <div className="g_between mb-3">
            <h4 className="card-title mb-4">{t("Interviews")}</h4>
            <Button
              color="primary"
              onClick={() => {
                setIsShowFilter(!isShowFilter)
              }}
              title={t("Show/Hide Filter")}
            >
              {isShowFilter ? <FilterX /> : <Filter />}
            </Button>
          </div> */}
          {/* {isShowFilter && ( */}
          <Filters
            filters={filters}
            state={{ ...payload.filters, order_by: payload.order_by }}
            setState={data => {
              const { order_by, ...rest } = data

              dispatch(
                setPayload({
                  order_by: Number(order_by),
                  filters: { ...payload.filters, ...rest },
                })
              )
            }}
            handleSearch={handleSearch}
            handleReset={handleReset}
          />
          <Card className="user_personal_info mt-3 theme_card">
            <CardBody>
              <div className="table-responsive">
                <Table className="table mb-0">
                  <thead className="table-light full_th">
                    <tr>
                      <th>{t("S. No.")}</th>
                      {/* <th>{t("Total Capacity")}</th>
                                <th>{t("Total User Enrolled")}</th>
                                <th>{t("Total Available Seat")}</th> */}
                      <th>{t("Name")}</th>
                      <th>{t("National Id")}</th>
                      <th>{t("Phone")}</th>
                      <th>{t("Nationality")}</th>
                      <th>{t("Schedule Date")}</th>
                      <th>{t("Schedule Time")}</th>
                      {activeTab === "2" && (
                        <>
                          <th>{t("Obtained Score")}</th>
                          <th>{t("Interviewed By")}</th>
                          <th>{t("Assign Job Title")}</th>
                          <th>{t("Submitted Date")}</th>
                          <th>{t("Trial Operation")}</th>
                        </>
                      )}
                      {activeTab == 3 && <th>{t("Cancelled Date")}</th>}
                      <th>{activeTab != 3 && t("Action")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {assessmentsList?.map((item, index) => (
                      <tr key={index} className="cursor-pointer">
                        <td>{(currentPage - 1) * perPage + index + 1}</td>
                        {/* <td>{item?.interview_schedule?.total_capacity}</td>
                                  <td>
                                    {item?.interview_schedule?.total_user_enrolled}
                                  </td>
                                  <td>
                                    {item?.interview_schedule?.total_available_seat}
                                  </td> */}
                        <td>{item?.user?.name}</td>
                        <td>{item?.user?.national_id}</td>
                        <td>
                          <p className="ltr fit_content">{item?.user?.phone}</p>
                        </td>
                        <td>{item?.user?.nationality_name}</td>
                        <td>
                          <p className="ltr fit_content">
                            {item?.interview_schedule?.start_date}
                          </p>
                        </td>
                        <td className="fit_content">
                          <p className="ltr fit_content">
                            {item?.interview_schedule?.start_time} ~{" "}
                            {item?.interview_schedule?.end_time}
                          </p>
                        </td>
                        {activeTab === "2" && (
                          <>
                            <td>{item?.obtained_score} </td>
                            <td>{item?.interviewer_by} </td>
                            <td>{item?.assign_job_title} </td>
                            <td>{item?.submitted_at} </td>
                            <td>
                              {item?.would_you_like_work_in_trial_period ===
                              true
                                ? t("Yes")
                                : t("No")}
                            </td>
                          </>
                        )}
                        {activeTab == "3" && <td>{item?.cancelled_at}</td>}
                        <td>
                          {!item?.is_submitted &&
                            activeTab != "3" &&
                            (showAll ||
                              iePermissions.includes(
                                "can_conduct_interview"
                              )) && (
                              <div className="d-flex gap-3 ">
                                <Button
                                  color="primary"
                                  className="fit_content"
                                  onClick={() => {
                                    toggle()
                                    setSelectedItem(item)
                                    // window.open(
                                    //   `/interview-appointments/start-assessment?uuid=${item?.user?.uuid}&interviewUuid=${item?.uuid}`,
                                    //   "_blank"
                                    // )
                                  }}
                                >
                                  {t("Start Interview")}
                                </Button>
                              </div>
                            )}

                          {/* SHOW VIEW BUTTON ONCE SUBMITTED */}
                          {item?.is_submitted &&
                            (showAll ||
                              permissions.includes("can_view_details")) && (
                              <Button
                                color="secondary"
                                className="fit_content"
                                onClick={() => {
                                  window.open(
                                    `/interview-appointments/view-assessment?uuid=${item?.user?.uuid}&interviewUuid=${item?.uuid}`,
                                    "_blank"
                                  )
                                }}
                              >
                                {t("View Details")}
                              </Button>
                            )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </CardBody>
          </Card>
          {!loading && assessmentsList.length > 0 && (
            <Paginations
              currentPage={currentPage}
              totalPages={totalPages}
              totalCount={totalCount}
              onPageChange={onPageChange}
            />
          )}
        </div>
      )}
      <Modal
        isOpen={modal}
        toggle={toggle}
        className=""
        backdrop="static"
        centered
      >
        <ModalHeader toggle={toggle}>
          {t("This interview is being recorded")}
        </ModalHeader>
        <ModalFooter>
          <div className="my-2">
            <Button
              color="success"
              type="submit"
              onClick={() => {
                toggle()
                window.open(
                  `/interview-appointments/start-assessment?uuid=${selectedItem?.user?.uuid}&interviewUuid=${selectedItem?.uuid}`,
                  "_blank"
                )
              }}
            >
              {t("Ok")}
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default InterviewTabs
